export type CreditCapacity = {
  exact: number | null;
  min: number | null;
  max: number | null;
};

export type CreditLotExpiry = {
  quantity: number;
  expiresAt: string;
};

export type CreditBalance = {
  creditType: string;
  available: number;
  reserved: number;
  grace: number;
  expirySchedule: CreditLotExpiry[];
  capacity: CreditCapacity | null;
};

export type CreditEntitlement = {
  active: boolean;
};

export type CreditPricingPayload = {
  kind: 'QUANTITY' | 'WHATSAPP';
  quantity?: number;
  category?: string;
  countries?: Record<string, number>;
};

export type ValidityCheckRequest = {
  pricing: CreditPricingPayload;
  at: string;
};

export type ValidityCheckResponse = {
  sufficient: boolean;
  reservableAtInstant: number;
};

export type CreditReservation = {
  reservationId: string;
  workspaceId: string;
  creditType: string;
  consumerId: string;
  status: string;
  amount: number;
  consumed: number;
  expiresAt: string;
  createdAt: string;
};

export type CreditType = 'WHATSAPP' | 'SMS' | 'EMAIL' | 'MARKET_INTELLIGENCE' | string;

export const MARKET_INTELLIGENCE_CREDIT_TYPE = 'MARKET_INTELLIGENCE' as const;
